window.Vue = require('vue');

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import PortalVue from 'portal-vue'
Vue.use(PortalVue);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import Animation from './components/Animation';
Vue.component('Animation', Animation);

import LoadingAnimation from './components/LoadingAnimation';
Vue.component('LoadingAnimation', LoadingAnimation);

import HeaderWarms from './components/HeaderWarms';
Vue.component('HeaderWarms', HeaderWarms);

import HeaderLang from './components/HeaderLang';
Vue.component('HeaderLang', HeaderLang)

import DropdownMenu from '@innologica/vue-dropdown-menu'
Vue.component('DropdownMenu', DropdownMenu)

import Modal from './components/Modal'
Vue.component('Modal', Modal)

import CookieLaw from 'vue-cookie-law'
Vue.component('CookieLaw', CookieLaw)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import SearchNavbar from './components/SearchNavbar'
Vue.component('SearchNavbar', SearchNavbar)

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)

Vue.filter('stripHTML', function (value) {
    const div = document.createElement('div');
    div.innerHTML = value;
    var text = div.textContent || div.innerText || '';

    return text;
});

Vue.filter('lang', function (value) {
    if (!window.hasOwnProperty('translations')) {
        return value;
    }
    return window.translations.hasOwnProperty(value) ?
        window.translations[value] :
        value;
})

Vue.filter('formatDate', function (input) {
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const date = new Date(input.replace(/ /g, "T"));
    const hours = date.getHours();
    let minutes = date.getMinutes();
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return (monthNames[date.getMonth()]) + " " + date.getDate() + ", " + date.getFullYear() + "  " + hours + ':' + minutes;
});

import NewsletterModal from './components/NewsletterModal'
import axios from 'axios'

window._header = new Vue({
    el: '#header',
    components: {NewsletterModal},
    data: {
        show_language: false,
        show_resources: false,
        show_community: false,
        show_me: false,
        show_menu: false,
        show_mobile_search: false,
        isSearchExpanded: false,
        messages: null,
    },
    methods: {
        showNewsletterModal() {
            this.$refs['newsletterModal'].showModal();
        },
        setNewsletterCookiesState(allowed) {
            this.$refs['newsletterModal'].setCookiesState(allowed);
        },
        fetchMessages() {
            axios.get('/messages.json').then((response) => {
                if (response.data.hasOwnProperty('unread')) {
                    this.messages = response.data['unread'];
                }
            }).finally(() => {
                window.setTimeout(() => {
                    this.fetchMessages();
                }, 30000);
            });
        }
    },
    created() {
    },
    mounted() {
        document.getElementById("page-container").removeAttribute('style');

        this.$refs['menu-wrapper'].classList.remove('hidden');
        if (this.$el.dataset['auth'] === '1') {
            this.$refs['messages'].classList.remove('hidden');
            this.fetchMessages();
        }

        const l = document.querySelectorAll('._tz');
        if (!l.length) {
            return;
        }

        const client_tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (!client_tz) {
            return;
        }
        const server_tz = document.body.dataset['tz'];
        if (!server_tz) {
            return;
        }

        if (client_tz.toLowerCase() !== server_tz.toLowerCase()) {
            location.href = '/setTz?tz=' + encodeURIComponent(client_tz) + '&next=' + encodeURIComponent(location.href);
        }

    }
});

import Alpine from 'alpinejs'

import HMSurvey from './components/HMSurvey'
window._footer = new Vue({
    el: '#newsletter',
    components: {HMSurvey},
    methods: {
        showNewsletterModal() {
            window._header.showNewsletterModal();
        }
    },
});

